<section class="flex" style="flex-direction: column;justify-content: space-around;">
  <div class="flex" style="justify-content: space-between;padding: 0 10px;" class="flex">
    
    <h3 style="font-size: 1.17em;">Fund Your Wallet</h3>
    <button mat-dialog-close="true" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
    <div class="flex" style="align-items: baseline;height: fit-content;" *ngIf="!select">
      <div>
        <p>Enter amount</p>
        <form [formGroup]="amountForm">
          <mat-form-field>
            <mat-label>Amount</mat-label>
            <input
              matInput
              formControlName="amount"
              currencyMask
              [(ngModel)]="amount"
              [options]="{
             prefix: '₦ ', 
             align: 'center',
        }"
            />
          </mat-form-field>
        </form>

        <div mat-dialog-actions align="center">
          <button
            style="width: 100%"
            [disabled]="!amountForm.valid"
            color="accent"
            mat-flat-button
            mat-button
            (click)="proceed()"
          >
            Proceed
          </button>
        </div>
      </div>
    </div>

    <div
      *ngIf="select"
      class="flex frame"
      style="flex-direction: column; transition: opacity 5s"
    >
      <!-- <p>If you were not redirected, kindly click the below button to complete your transaction</p>
    <br>
    <a mat-raised-button color="accent" [href]="cleanURl(url)">Complete Transaction</a>
    -->
      <div *ngIf="select" class="frame">
        <h3 matDialogTitle>Choose Payment Channel</h3>
        <div class="flex button__wrapper">
          <!-- <div>
            <button (click)="fundWallet('flutterwave')" mat-button>
              <img height="80" src="https://customerdocument.blob.core.windows.net/customerdocuments/flutterwave.png"  alt="" />
            </button>
          </div> -->

          <div>
            <button (click)="fundWallet('paystack')" mat-button>
              <img
                height="30"
                src="https://customerdocument.blob.core.windows.net/customerdocuments/paystack-logo-removebg-preview.png"
                alt=""
              />
            </button>
          </div>
        </div>
      </div>
      <!-- <div style="width: inherit; height: 90%;">

      <iframe [src]="cleanURl(url)" frameborder="0"></iframe>
    </div>
    <div class="flex" style="width: 100%; justify-content: end;">
      <div style="width: fit-content;gap: 10px;" class="flex">

        <button mat-stroked-button (click)="close()" color="warn">Cancel</button>
        <button mat-flat-button color="accent" (click)="confirm()">Finish</button>
      </div>
    </div> -->
    </div>
</section>
